import shipment_rate from "../images/shipment-rate.png"
import Blog from "../component/Blog";
import Cta from "../component/Cta";
import logo from "../images/icon/dhl-logo.png"
import { Helmet } from "react-helmet";
export default function ShipmentRateCalc() {
    
    return (
        <div>
            <Helmet>
                <title>Parcelx - Shipment Rate</title>
            </Helmet>
            <section className="section03">
                <div className="container-fluid">
                    <div className="col-md-11 mx-auto">
                        <div className="row align-items-center">
                            <div className="col-md-8 order-md-2 mb-3">
                                <div className="mr-400">
                                    <img src={shipment_rate} className="img-fluid" alt="" />
                                </div>
                            </div>
                            <div className="col-md-4 mb-3">
                                <div className="section-heading">
                                    <h2 className="heading">Shipment Rate  <span>Calculator...</span></h2>
                                    <p className="">These shipping rates are for brands having less than 500 monthly orders</p>
                                </div>
                            </div>
                        </div>
                        <div className="shipment-box">
                            <div className="table-box">
                                <div className="shipment-table-head mb-24">
                                    <form >
                                        <div className="row">
                                            <div className="col-md-3 mb-3">
                                                <div>
                                                    <label htmlFor="From" className="form-label">From</label>
                                                    <input className="form-control" id="From" placeholder="Enter Pincode" type="text" />
                                                </div>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <div>
                                                    <label htmlFor="To" className="form-label">Breadth</label>
                                                    <input className="form-control" id="To" placeholder="Enter Pincode" type="text"/>
                                                </div>
                                            </div>
                                            <div className="col-md-2 mb-3">
                                                <div>
                                                    <label htmlFor="Payment" className="form-label">Payment Mode <span>*</span></label>
                                                    <select className="form-select" id="Payment" aria-label="Default select example" >
                                                        <option>select</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-2 mb-3">
                                                <div>
                                                    <label htmlFor="COD" className="form-label">COD Amount <span>*</span></label>
                                                    <input className="form-control" id="COD" placeholder="Enter Amount" type="text"/>
                                                </div>
                                            </div>
                                            <div className="col-md-2 mb-3">
                                                <div>
                                                    <label htmlFor="Invoice" className="form-label">Invoice Amount <span>*</span></label>
                                                    <input className="form-control" id="Invoice" placeholder="Enter Amount" type="text"/>
                                                </div>
                                            </div>
                                            <div className="col-md-2 mb-3">
                                                <div>
                                                    <label htmlFor="Quantity" className="form-label">Quantity <span>*</span></label>
                                                    <input className="form-control" id="Quantity" placeholder="Enter Quantity" type="text"/>
                                                </div>
                                            </div>
                                            <div className="col-md-2 mb-3">
                                                <div>
                                                    <label htmlFor="Weight" className="form-label">Weight <span>*</span></label>
                                                    <input className="form-control" id="Weight" placeholder="Enter Weight" type="text"/>
                                                </div>
                                            </div>
                                            <div className="col-md-2 mb-3">
                                                <div>
                                                    <label htmlFor="Length" className="form-label">Length <span>*</span></label>
                                                    <input className="form-control" id="Length" placeholder="Enter Length" type="text" />
                                                </div>
                                            </div>
                                            <div className="col-md-2 mb-3">
                                                <div>
                                                    <label htmlFor="Width" className="form-label">Width <span>*</span></label>
                                                    <input className="form-control" id="Width" placeholder="Enter Width" type="text"/>
                                                </div>
                                            </div>
                                            <div className="col-md-2 mb-3">
                                                <div>
                                                    <label htmlFor="Height" className="form-label">Height <span>*</span></label>
                                                    <input className="form-control" id="Height" placeholder="Enter Height" type="text"/>
                                                </div>
                                            </div>
                                            <div className="col-md-2 mb-3">
                                                <div className="input-search-box">
                                                    <button className="btn btn-primary w-100 btn-sm mt-auto" type="submit"><i className="fas fa-search me-2"></i> Search</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="shipment-table-head">
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <h4 className="f-20 fw-600">Serviceable Courier Partner </h4>
                                                    <p>Showing 05 serviceable couriers</p>
                                                </div>
                                                <div className="col-md-4">
                                                    <div>
                                                        <button className="btn btn-filter active">All</button>
                                                        <button className="btn btn-filter">Surface</button>
                                                        <button className="btn btn-filter">Air</button>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <select className="form-select" aria-label="Default select example" defaultValue="1">
                                                        <option value="1">Filter:  Low to High</option>
                                                        <option value="2">Filter: High to Low  </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <table className="table mb-0">
                                                <thead>
                                                    <tr>
                                                    <th scope="col">Courier Name</th>
                                                    <th scope="col">EDD</th>
                                                    <th scope="col">Insurance</th>
                                                    <th scope="col">Charges</th>
                                                    <th scope="col">GST</th>
                                                    <th scope="col">Total Charges</th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                        <div className="shipment-table-head py-2">
                                            <table className="table v-center">
                                                <tbody>
                                                    <tr>
                                                        <td><img src={logo} className="img-fluid me-3" /> Delhivery</td>
                                                        <td><p className="shipment-date">3 - 5 Days</p></td>
                                                        <td>
                                                            <div className="form-check form-switch">
                                                                <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                                                                <label className="form-check-label" for="flexSwitchCheckDefault"></label>
                                                            </div>
                                                        </td>
                                                        <td>Rs 35 <i className="far fa-info-circle"></i></td>
                                                        <td>Rs 4.18</td>
                                                        <td className="totle">Rs 39.18</td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src={logo} className="img-fluid me-3" /> Delhivery</td>
                                                        <td><p className="shipment-date">3 - 5 Days</p></td>
                                                        <td>
                                                            <div className="form-check form-switch">
                                                                <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                                                                <label className="form-check-label" for="flexSwitchCheckDefault"></label>
                                                            </div>
                                                        </td>
                                                        <td>Rs 35 <i className="far fa-info-circle"></i></td>
                                                        <td>Rs 4.18</td>
                                                        <td className="totle">Rs 39.18</td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src={logo} className="img-fluid me-3" /> Delhivery</td>
                                                        <td><p className="shipment-date">3 - 5 Days</p></td>
                                                        <td>
                                                            <div className="form-check form-switch">
                                                                <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                                                                <label className="form-check-label" for="flexSwitchCheckDefault"></label>
                                                            </div>
                                                        </td>
                                                        <td>Rs 35 <i className="far fa-info-circle"></i></td>
                                                        <td>Rs 4.18</td>
                                                        <td className="totle">Rs 39.18</td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src={logo} className="img-fluid me-3" /> Delhivery</td>
                                                        <td><p className="shipment-date">3 - 5 Days</p></td>
                                                        <td>
                                                            <div className="form-check form-switch">
                                                                <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                                                                <label className="form-check-label" for="flexSwitchCheckDefault"></label>
                                                            </div>
                                                        </td>
                                                        <td>Rs 35 <i className="far fa-info-circle"></i></td>
                                                        <td>Rs 4.18</td>
                                                        <td className="totle">Rs 39.18</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d13032104.46538898!2d78.55584313013159!3d20.465048354203883!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sin!4v1758270764826!5m2!1sen!2sin" width="100%" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Blog />
            <Cta />
        </div>
    )
}